import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { importViolationListFailed, importViolationListSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* importViolationList(action) {
  try {
    const url = `${BACKEND_URL}/api/v1/violation-list-file`;
    const dataResponse = yield makeRequest(url, action.payload, action, 'POST', true, {}, true);
    if (dataResponse.status === OK) {
      yield put(importViolationListSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      const data = yield dataResponse.json();
      yield put(importViolationListFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(importViolationListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
